// extracted by mini-css-extract-plugin
export default {"Icon":"SessionMaterial_Icon__l2whN","fileName":"SessionMaterial_fileName__qM5u8"};